import React from 'react'
import Loadable from 'react-loadable'

import Loading from '../../components/loader/Loader'
import RolesEnum from '../../Enum/RolesEnum';

const MotoristasComponent = Loadable({
  loader: () => import('../../../pages/motorista/Motoristas'),
  loading: () => <Loading />
})

export default [
  {
    path: '/motoristas',
    title: 'Motoristas',
    component: MotoristasComponent,
    isAuthenticated: true,
    roles: [RolesEnum.Resale, RolesEnum.FuncionarioRevenda, RolesEnum.Organizacao]
  }
]
